import React from "react";

import { Wrapper } from "./Buttons.styles";

const Buttons = ({ children }) => <Wrapper>{children}</Wrapper>;

export default Buttons;
